import GaResource from '@/resources/GaResource';

export default class Ga {
    constructor() {
        this.Resource = new GaResource()
    }

    async connect (websiteId, googleId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await this.Resource.connect(websiteId, googleId, isAlwaysPushPageViews, sendDisapproveTransactions)
    }

    async updateConnection (websiteId, googleId, isAlwaysPushPageViews, sendDisapproveTransactions) {
        return await this.Resource.updateConnection(websiteId, googleId, isAlwaysPushPageViews, sendDisapproveTransactions)
    }
}